import type { SUSContact } from '@/models/sus.type';
import { Anchor, Tooltip } from '@mantine/core';

type Props = {
  contact: SUSContact;
};

/** Nom du contact, avec son email en infobulle et en lien `mailto:`. */
const SusContact = ({ contact: { libelle, email } }: Props) => (
  <Tooltip label={email} withArrow position="left-start">
    <Anchor
      href={`mailto:${email}`}
      size="sm"
      style={{
        whiteSpace: 'nowrap',
      }}
    >
      {libelle}
    </Anchor>
  </Tooltip>
);

export default SusContact;
